import { getAllUsers } from '../api/user'
import { isUserActive } from './auth'

/**
 * This function tries to fetch the user list if is not cached.
 *
 * @returns array
 */
export const getUserList = async () => {
  let userList = getUserListFromCache() || []

  if (userList.length === 0) {
    const { data } = await getAllUsers()
    userList = data.data.filter(user => isUserActive(user))

    localStorage.setItem(
      'userList',
      JSON.stringify({ list: userList, timestamp: Date.now() })
    )
  }

  return userList
}

export const getUserById = async id => {
  const userList = await getUserList()
  return userList.find(user => user.id == id)
}
/**
 * This function returns the user list from cache.
 * The cache is valid for 1 hour.
 *
 * @returns array
 */
const getUserListFromCache = () => {
  const userList = JSON.parse(localStorage.getItem('userList')) || {}
  const { list, timestamp } = userList
  const HOUR_IN_MILLISECONDS = 3600000
  const isExpired = Date.now() - timestamp > HOUR_IN_MILLISECONDS

  return list && !isExpired ? list : []
}
